import React, {Suspense} from "react";
import {DemoDashboardOverview} from "../../components/Dashboard/DemoDashboardOverview";
import {defer, LoaderFunctionArgs, useLoaderData, Await} from "react-router-dom";
import {getDemoDispatches} from "../../api/demoDispatchClient";
import {getDemoTemplatesPreview} from "../../api/demoConfigClient";
import {DemoDispatch} from "../../model/DemoDispatch";
import {DemoTemplatePreview} from "../../model/DemoTemplatePreview";
import {CircularProgress} from "@mui/material";

const DemoDashboardPage: React.FC = () => {
    const { demoDispatches, demoTemplatesPreview } = useLoaderData() as { 
        demoDispatches: Promise<DemoDispatch[]>;
        demoTemplatesPreview: Promise<DemoTemplatePreview[]>;
    };
    
    return (
        <Suspense fallback={<CircularProgress/>}>
            <Await resolve={Promise.all([demoDispatches, demoTemplatesPreview])}>
                {([dispatches, templates]) => (
                    <DemoDashboardOverview 
                        demoDispatches={dispatches} 
                        demoTemplatesPreview={templates}
                    />
                )}
            </Await>
        </Suspense>
    )
}

export default DemoDashboardPage

async function loadDemoDispatches(customerId: string): Promise<DemoDispatch[]> {
    try {
        return await getDemoDispatches(customerId);
    } catch (error) {
        return [];
    }
}

async function loadDemoTemplatesPreview(customerId: string): Promise<DemoTemplatePreview[]> {
    try {
        return await getDemoTemplatesPreview(customerId);
    } catch (error) {
        return [];
    }
}

export async function loader({ params }: LoaderFunctionArgs) {
    const customerId = params.customerId!;
    
    return defer({
        demoDispatches: loadDemoDispatches(customerId),
        demoTemplatesPreview: loadDemoTemplatesPreview(customerId)
    });
}
